<script lang="ts" setup>
import { VAnimatedBackground } from "@app/core";
import { RouterView } from "vue-router";

import ThemeToggle from "@/features/theme/components/ThemeToggle.vue";
</script>

<template>
  <div class="min-h-screen bg-base-100 text-neutral flex items-center justify-center">
    <VAnimatedBackground />

    <div class="w-full max-w-md">
      <div class="absolute top-4 right-4 z-[20]">
        <ThemeToggle />
      </div>
      <RouterView />
    </div>
  </div>
</template>
